<form class="tw-w-full tw-h-fit tw-mb-4" [formGroup]="formGroup">
  <div class="tw-w-fit tw-h-fit tw-flex tw-items-center tw-mb-2">
    <div (click)="fileInput.click()" class="tw-w-fit tw-h-fit tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-[5px] tw-cursor-pointer tw-p-2">
      <input #fileInput type="file" class="tw-hidden" (change)="onFileSelected($event)" accept="image/*" />
      <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/image-upload-icon.svg" />
    </div>
    <p *ngIf="label && label != ''" class="tw-w-fit tw-h-full tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-pl-2">
      {{ label | translate }}
    </p>
  </div>
  <div
    *ngIf="formGroup.value[imageFormControlName] && formGroup.value[imageFormControlName] != ''"
    class="tw-w-48 tw-h-24 tw-relative tw-flex tw-justify-center tw-items-center tw-bg-white/50 tw-rounded-[5px] tw-overflow-hidden tw-mb-2"
  >
    <img (click)="deleteFile()" class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-top-2 tw-right-2 tw-cursor-pointer" src="../../../assets/image-delete-icon.svg" />
    <img class="tw-w-full tw-h-full tw-object-cover" [src]="formGroup.value[imageFormControlName]" />
  </div>
  <div *ngIf="formGroup.get(imageFormControlName).invalid && (formGroup.get(imageFormControlName).touched || formGroup.get(imageFormControlName).dirty)">
    <small *ngIf="formGroup.get(imageFormControlName).errors['required']" class="tw-font-poppins tw-font-medium tw-text-xs tw-text-warning">{{ "image-is-required" | translate }}</small>
  </div>
</form>
